/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();

      this.onColorSwatchClickBound = this.onColorSwatchClick.bind(this);
      this.onColorSwatchMouseEnterBound =
        this.onColorSwatchMouseEnter.bind(this);
      this.onSwatchMouseLeaveBound = this.onSwatchMouseLeave.bind(this);
      this.onVariantChangedBound = this.onVariantChanged.bind(this);
      this.onSwatchKeydownBound = this.onSwatchKeydown.bind(this);
      this.check = this.checkState.bind(this);
    }

    connectedCallback() {
      this.colorLabel = this.querySelector("[data-color-swatch-name]");
      this.colorLabelState = this.querySelector("[data-color-swatch-state]");
      this.soldOutString = this.getAttribute("data-swatch-sold-out-string");
      this.productForm =
        this.closest(".product-single-wrapper") || this.closest("#product-box");
      this.colorSwatches = this.querySelectorAll(".swatch-element.color");
      this.textSwatches = this.querySelectorAll(".swatch-element:not(.color)");
      this.ariaSwatches = this.querySelectorAll(
        ".swatch-element[role='radio']"
      );
      this.checkCheckbox = document.querySelectorAll(
        "#additional-voltage-checkbox"
      );
      this.setEventListeners();
      this.setColorLabelState();
      this.updateAriaState();
      this.checkState();
    }

    setEventListeners() {
      this.colorSwatches.forEach((swatch) => {
        swatch.addEventListener("click", this.onColorSwatchClickBound);
        swatch.addEventListener(
          "mouseenter",
          this.onColorSwatchMouseEnterBound
        );
        swatch.addEventListener("mouseleave", this.onSwatchMouseLeaveBound);
      });

      this.ariaSwatches.forEach((swatch) => {
        swatch.addEventListener("keydown", this.onSwatchKeydownBound);
      });

      this.checkCheckbox.forEach((box) => {
        box.addEventListener("click", this.check);
      });

      if (this.productForm)
        this.productForm.addEventListener(
          "variant:changed",
          this.onVariantChangedBound
        );
    }

    // APG radiogroup keyboard pattern for swatch options.
    // Arrow / Home / End navigate with wrap; select-follows-focus.
    // Space / Enter activate via the existing click chain.
    onSwatchKeydown(event) {
      const key = event.key;
      const navigationKeys = [
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];
      const activationKeys = [" ", "Spacebar", "Enter"];

      if (activationKeys.indexOf(key) !== -1) {
        event.preventDefault();
        this.activateSwatch(event.currentTarget);
        return;
      }

      if (navigationKeys.indexOf(key) === -1) return;

      event.preventDefault();

      const current = event.currentTarget;
      const group = current.closest("product-swatch") || this;
      const options = Array.from(
        group.querySelectorAll(".swatch-element[role='radio']")
      );
      if (options.length === 0) return;

      const currentIndex = options.indexOf(current);
      let targetIndex = currentIndex;

      if (key === "ArrowRight" || key === "ArrowDown") {
        targetIndex = currentIndex + 1;
        if (targetIndex >= options.length) targetIndex = 0;
      } else if (key === "ArrowLeft" || key === "ArrowUp") {
        targetIndex = currentIndex - 1;
        if (targetIndex < 0) targetIndex = options.length - 1;
      } else if (key === "Home") {
        targetIndex = 0;
      } else if (key === "End") {
        targetIndex = options.length - 1;
      }

      const target = options[targetIndex];
      if (!target) return;

      // APG "select follows focus" pattern: activating before focusing
      // reuses the existing label.click -> Vue v-model -> variant:changed
      // chain, so price / ATC update as a side effect of the theme's own JS.
      this.activateSwatch(target);
      target.focus();
    }

    // Reuse the existing click chain. Clicking the inner <label> triggers
    // the native radio's checked state, which Vue's v-model binding picks up,
    // which fires variant:changed, which runs onVariantChanged. We never
    // invent a new variant-selection codepath.
    //
    // Note: sold-out swatches are NOT guarded here. The theme's mouse-click
    // behavior on a sold-out swatch is identical: click goes through, and
    // onVariantChanged's variant-cascade logic picks the first available
    // variant with a matching option. Keeping keyboard parity with mouse
    // click avoids diverging behaviors; aria-disabled="true" communicates
    // unavailability to AT without blocking interaction.
    activateSwatch(swatch) {
      if (!swatch) return;
      const label = swatch.querySelector("label");
      if (label) {
        label.click();
      } else {
        swatch.click();
      }
    }

    // IMPORTANT: sync aria-checked / roving tabindex from the native radio's
    // .checked state, NOT from the ".active" class on the swatch wrapper.
    // The theme has a pre-existing bug in snippets/swatch.liquid where
    // data-value is truncated to 22 chars; the theme's own onVariantChanged
    // then queries [data-value="<full variant option>"] and fails to find
    // swatches whose option names are longer than 22 chars, leaving the
    // .active class stale for any long-named option. The native radio is
    // always correctly checked (Shopify / Vue v-model drives it from the
    // form value), so we sync from there.
    updateAriaState() {
      const options = this.querySelectorAll(".swatch-element[role='radio']");
      options.forEach((option) => {
        const radio = option.querySelector("input[type='radio']");
        const isChecked = radio ? radio.checked : false;
        option.setAttribute("aria-checked", isChecked ? "true" : "false");
        option.setAttribute("tabindex", isChecked ? "0" : "-1");
        const isSoldOut = option.classList.contains("soldout");
        if (isSoldOut) {
          option.setAttribute("aria-disabled", "true");
        } else {
          option.removeAttribute("aria-disabled");
        }
      });
    }

    setColorLabelState() {
      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (!activeSwatch) return;

      const activeSwatchAvailable = activeSwatch.getAttribute(
        "data-swatch-option-available"
      );
      if (!this.soldOutString || !this.colorLabelState) return;

      this.colorLabelState.innerText =
        activeSwatchAvailable == "false" ? `(${this.soldOutString})` : "";
    }

    onColorSwatchClick(event) {
      this.updateColorLabel(event.currentTarget);
    }

    onColorSwatchMouseEnter(event) {
      // Update color label
      this.updateColorLabel(event.currentTarget);

      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (activeSwatch && !event.currentTarget.classList.contains("active"))
        activeSwatch.classList.add("sibling-hover-active");
    }

    onSwatchMouseLeave() {
      const siblingHoverActiveSwatch = this.querySelector(
        ".swatch-element.sibling-hover-active"
      );
      if (siblingHoverActiveSwatch)
        siblingHoverActiveSwatch.classList.remove("sibling-hover-active");

      // Reset color label
      this.resetColorLabel();
    }

    updateColorLabel = (swatch) => {
      if (!swatch) return;
      const label = swatch.getAttribute("data-value");
      const swatchAvailable = swatch.getAttribute(
        "data-swatch-option-available"
      );

      if (!label || !this.colorLabel) return;
      this.colorLabel.textContent = label;
      if (this.colorLabelState)
        this.colorLabelState.innerText =
          swatchAvailable == "false" ? `(${this.soldOutString})` : "";
    };

    resetColorLabel = () => {
      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (!activeSwatch || !this.colorLabel) return;

      const activeSwatchValue = activeSwatch.getAttribute("data-value");
      const swatchAvailable = activeSwatch.getAttribute(
        "data-swatch-option-available"
      );
      if (!activeSwatchValue) return;

      this.colorLabel.textContent = activeSwatchValue;
      if (this.colorLabelState)
        this.colorLabelState.innerText =
          swatchAvailable == "false" ? `(${this.soldOutString})` : "";
    };

    setActiveClass = (swatch) => {
      if (!swatch) return;
      swatch.classList.add("active");
    };

    removeActiveClass = (swatch) => {
      if (!swatch) return;
      swatch.classList.remove("active");
    };

    checkState = () => {
      const checkbox = document.getElementById("additional-voltage-checkbox");
      if (!checkbox) return;
      const notification = document.getElementById("voltage-acknowledgment");
      const swatch220v = this.querySelector('.swatch-element[data-value="220V"]');
      const is220vActive = !!(swatch220v && swatch220v.classList.contains("active"));

      if (notification) notification.hidden = !is220vActive;

      const addToCartButton = document.getElementById("AddToCart");
      const dynamicAddToCartBtns = document.querySelectorAll(
        ".sticky-add__btn #AddToCart"
      );
      const mustAcknowledge = is220vActive && !checkbox.checked;
      const setDisabled = (btn) => {
        if (!btn) return;
        btn.disabled = mustAcknowledge;
        btn.setAttribute("aria-disabled", mustAcknowledge ? "true" : "false");
        if (mustAcknowledge) {
          btn.setAttribute("aria-describedby", "voltage-acknowledgment-text");
        } else {
          btn.removeAttribute("aria-describedby");
        }
      };

      setDisabled(addToCartButton);
      dynamicAddToCartBtns.forEach(setDisabled);
    };

    onVariantChanged(event) {
      if (!event.detail.variant) {
        const product = event.detail.product;
        let selectedVariant;

        if (product.options.length == 3) {
          const selectedOption1 = document.querySelector(
            "input:checked[name='option-1']"
          ).value;
          const selectedOption2 = document.querySelector(
            "input:checked[name='option-2']"
          ).value;
          const selectedOption3 = document.querySelector(
            "input:checked[name='option-3']"
          ).value;

          // find variant where first two options match and is available
          selectedVariant = product.variants.find(
            (v) =>
              v.available &&
              v.options[0] === selectedOption1 &&
              v.options[1] === selectedOption2
          );

          // if not found, find where first option matches and is available
          if (!selectedVariant) {
            selectedVariant = product.variants.find(
              (v) => v.available && v.options[0] === selectedOption1
            );
          }

          // otherwise find first available
          if (!selectedVariant) {
            selectedVariant = product.variants.find((v) => v.available);
          }
        } else if (product.options.length == 2) {
          const selectedOption1 = document.querySelector(
            "input:checked[name='option-1']"
          ).value;

          // find variant where first option matches and is available
          selectedVariant = product.variants.find(
            (v) => v.available && v.options[0] === selectedOption1
          );

          // otherwise find first available
          if (!selectedVariant) {
            selectedVariant = product.variants.find((v) => v.available);
          }
        } else {
          // find first available variant
          selectedVariant = product.variants.find((v) => v.available);
        }

        // Click the option inputs to select the variant
        if (selectedVariant) {
          for (let i = 0; i < product.options.length; i++) {
            document
              .querySelector(
                `[data-option='${product.options[i]}'] input[value='${selectedVariant.options[i]}']`
              )
              ?.click();
          }
        }

        this.updateAriaState();
        return;
      }

      if (
        event.detail.variant.id == 45930871423028 ||
        event.detail.variant.id == 45930871455796
      ) {
        document
          .querySelector("[data-option='Voltage'] input[value='No Voltage']")
          .click();
        this.updateAriaState();
        return;
      }

      const productSingleWrapper = this.closest(".product-single-wrapper");
      if (productSingleWrapper) {
        productSingleWrapper.setAttribute(
          "selected-variant-id",
          event.detail.variant.id
        );
      }
      if (
        event.detail.variant.id == 45770500472884 ||
        event.detail.variant.id == 45768682766388 ||
        event.detail.variant.id == 45810787287092
      ) {
        setTimeout(() => {
          document.getElementById("AddToCart").disabled = false;
        }, 200);
      }
      window.dispatchEvent(
        new CustomEvent("variant:changed", { detail: event.detail })
      );
      const product = event.detail.product;

      if (!product) return;

      const variant = event.detail.variant;
      if (!variant) return;

      const swatchSelectedSize = document.querySelector(
        "[data-swatch-selected-size]"
      );
      let sizeIndex = product.options.indexOf("Size");
      if (sizeIndex === -1) {
        sizeIndex = product.options.indexOf("Model");
      }

      const selectedSize = variant[`option${sizeIndex + 1}`];
      if (swatchSelectedSize) {
        swatchSelectedSize.innerHTML = selectedSize;
      }

      // Set active swatches based on the selected variant
      product.options.forEach((option, index) => {
        // Remove active class from all swatches
        const swatches = this.querySelectorAll(
          `.swatch-element[data-option="${option}"]`
        );
        swatches.forEach((swatch) => this.removeActiveClass(swatch));

        // Set active class on the swatch that matches the selected variant
        const swatch = this.querySelector(
          `.swatch-element[data-option="${option}"][data-value='${
            variant[`option${index + 1}`]
          }']`
        );

        if (swatch) this.setActiveClass(swatch);

        this.checkState();
      });

      const activeSwatches = Array.from(
        this.productForm.querySelectorAll(
          ".swatch-element.variant-swatch.active"
        )
      )
        .map((swatch) => swatch.getAttribute("data-value"))
        .filter(Boolean);

      if (activeSwatches.length < product.options.length) return;

      const selectedVariantTitle = activeSwatches.join(" / ");
      const selectedVariant = product.variants.find(
        (variant) => variant.title === selectedVariantTitle
      );
      if (!selectedVariant) return;

      product.options.forEach((option, index) => {
        const optionValues = product.variants.map(
          (variant) => variant[`option${index + 1}`]
        );
        optionValues.forEach((value) => {
          this.updateSwatchStates(
            product,
            value,
            index + 1,
            selectedVariant,
            option
          );
        });
      });

      // Sync ARIA state after the theme's own .active / soldout updates.
      // Syncs from native radio.checked (not .active) to survive the
      // pre-existing truncate:22 querySelector bug.
      this.updateAriaState();
    }

    updateSwatchStates(product, value, optionIndex, currentVariant, option) {
      const availability = product.variants.map((variant) => variant.available);
      const optionValues = [
        product.variants.map((variant) => variant.option1),
        product.variants.map((variant) => variant.option2),
        product.variants.map((variant) => variant.option3),
      ];

      const isOptionAvailable = optionValues[optionIndex - 1].some(
        (optionValue, i) => {
          switch (optionIndex) {
            case 1:
              return optionValue === value && availability[i];
            case 2:
              return (
                optionValue === value &&
                optionValues[0][i] === currentVariant.option1 &&
                availability[i]
              );
            case 3:
              return (
                optionValue === value &&
                optionValues[0][i] === currentVariant.option1 &&
                optionValues[1][i] === currentVariant.option2 &&
                availability[i]
              );
            default:
              return false;
          }
        }
      );

      const swatches = this.productForm.querySelectorAll(
        `.swatch-element.variant-swatch[data-option="${option}"][data-value="${value}"]`
      );
      swatches.forEach((swatch) => {
        if (isOptionAvailable) {
          swatch.classList.remove("soldout");
          swatch.setAttribute("data-swatch-option-available", true);
        } else {
          swatch.classList.add("soldout");
          swatch.setAttribute("data-swatch-option-available", false);
        }
      });

      const activeSwatch = this.querySelector(".swatch-element.color.active");
      if (activeSwatch) this.updateColorLabel(activeSwatch);

      // Sync ARIA disabled / checked after sold-out flips.
      this.updateAriaState();
    }

    removeEventListeners() {
      this.colorSwatches.forEach((swatch) => {
        swatch.removeEventListener("click", this.onColorSwatchClickBound);
        swatch.removeEventListener(
          "mouseenter",
          this.onColorSwatchMouseEnterBound
        );
        swatch.removeEventListener("mouseleave", this.onSwatchMouseLeaveBound);
      });

      if (this.ariaSwatches) {
        this.ariaSwatches.forEach((swatch) => {
          swatch.removeEventListener("keydown", this.onSwatchKeydownBound);
        });
      }

      if (this.productForm)
        this.productForm.removeEventListener(
          "variant:changed",
          this.onVariantChangedBound
        );
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }
  }

  if (!window.customElements.get("product-swatch")) {
    window.customElements.define("product-swatch", ProductSwatch);
  }

  /******/
})();
